function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSmall = function SvgLivemapSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4501",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5967-268.179v-13.845l6.333-2.411 5.625 2.249 6.33-2.411v7.053a5.433 5.433 0 0 0-.852-.617v-5.2l-5.486 2.087-5.625-2.249-5.474 2.089v12.025l5.481-2.089 2.755 1.1c.152.389.31.759.467 1.1l-3.229-1.291-6.324 2.409z",
    "data-name": "Subtraction 1",
    style: {
      fill: "#fff"
    },
    transform: "translate(5969 286.426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.54 101.87h.851v12.936h-.851z",
    "data-name": "Path 11758",
    style: {
      stroke: "#fff",
      strokeWidth: ".1px",
      fill: "#fff"
    },
    transform: "translate(-379.634 -99.423)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.61 249.5h.851v3.18l-.851.3z",
    "data-name": "Path 11759",
    style: {
      stroke: "#fff",
      strokeWidth: ".1px",
      fill: "#fff"
    },
    transform: "translate(-743.08 -244.803)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22040.766-11627.216a23.25 23.25 0 0 1-2.371-2.719c-1.484-2.01-2.234-3.774-2.234-5.254a4.767 4.767 0 0 1 4.867-4.646 4.767 4.767 0 0 1 4.863 4.646c0 3.545-4.418 7.8-4.6 7.973a.385.385 0 0 1-.258.105.378.378 0 0 1-.27-.105zm-3.863-7.973a8.221 8.221 0 0 0 1.766 4.356 23.565 23.565 0 0 0 2.359 2.844 22.957 22.957 0 0 0 2.355-2.844 8.181 8.181 0 0 0 1.762-4.356 4.034 4.034 0 0 0-4.117-3.932 4.039 4.039 0 0 0-4.128 3.933zm4.117 2.587a2.577 2.577 0 0 1-1.785-.829 2.569 2.569 0 0 1-.687-1.842 2.574 2.574 0 0 1 .789-1.785 2.579 2.579 0 0 1 1.844-.73 2.573 2.573 0 0 1 1.809.776 2.567 2.567 0 0 1 .746 1.821 2.621 2.621 0 0 1-.8 1.839 2.622 2.622 0 0 1-1.852.753zm-1.777-2.534a1.868 1.868 0 0 0 1.875 1.818h.027a1.882 1.882 0 0 0 1.844-1.875 1.911 1.911 0 0 0-1.918-1.875h-.043a1.891 1.891 0 0 0-1.785 1.938z",
    "data-name": "Path 11622",
    style: {
      fill: "#fff"
    },
    transform: "translate(-22024.605 11648.598)"
  }));
};
export default SvgLivemapSmall;